import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getGetTasksByCourseModuleQueryKey } from '@/common/api/endpoints/tasks/tasks';

const MODULE_TASK_INCLUDES = { include: 'submissions,resources' } as const;

/** Refetch module tasks after a student-facing load failure (e.g. oral exam pool unavailable). */
export function useRefetchModuleTasks(courseId: string, moduleId: string) {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    const baseKey = getGetTasksByCourseModuleQueryKey(courseId, moduleId);
    const fullKey = getGetTasksByCourseModuleQueryKey(courseId, moduleId, MODULE_TASK_INCLUDES);

    await Promise.all([
      queryClient.invalidateQueries({ queryKey: baseKey }),
      queryClient.invalidateQueries({ queryKey: fullKey }),
    ]);
    await queryClient.refetchQueries({ queryKey: fullKey });
  }, [queryClient, courseId, moduleId]);
}
